export const ROLEX_SERVICE_PROCEDURE_URL = Object.freeze({
  localized:
    'https://www.rolex.com/{locale}/watch-care-and-service/the-rolex-servicing-procedure',
  default:
    'https://www.rolex.com/watch-care-and-service/the-rolex-servicing-procedure',
});

/**
 * Canonical locale codes used by i18next in this application.
 */
export const supportedLocales = Object.freeze([
  'en',
  'fr',
  'en-US',
  'it',
  'zh-Hant',
  'es',
  'ko',
  'ar',
  'id',
  'fa',
  'vi',
  'pl',
  'ms',
  'de',
  'zh-Hans',
  'ja',
  'pt-BR',
  'ru',
  'tr',
  'th',
  'nl',
  'hi',
  'he',
]);

/**
 * Browser and regional locale aliases mapped to the canonical application locale.
 */
const LOCALE_ALIASES = Object.freeze({
  // Portuguese
  pt: 'pt-BR',
  'pt-br': 'pt-BR',
  'pt-pt': 'pt-BR',

  // Simplified Chinese
  zh: 'zh-Hans',
  'zh-cn': 'zh-Hans',
  'zh-sg': 'zh-Hans',
  'zh-hans': 'zh-Hans',

  // Traditional Chinese
  'zh-tw': 'zh-Hant',
  'zh-hk': 'zh-Hant',
  'zh-mo': 'zh-Hant',
  'zh-hant': 'zh-Hant',

  // Existing application fallback
  'en-ca': 'en-US',
});

/**
 * Canonical i18next locale -> existing public/locales directory name.
 */
const LOCALE_DIRECTORIES = Object.freeze({
  'en-US': 'en-US',
  'pt-BR': 'pt-br',
  'zh-Hans': 'zh-hans',
  'zh-Hant': 'zh-hant',
});

/**
 * Converts a browser, API, or stored locale to a supported canonical locale.
 */
export const normalizeLocale = (locale) => {
  if (typeof locale !== 'string' || !locale.trim()) {
    return 'en';
  }

  const normalizedLocale = locale.trim().replace(/_/g, '-').toLowerCase();

  if (LOCALE_ALIASES[normalizedLocale]) {
    return LOCALE_ALIASES[normalizedLocale];
  }

  const exactLocale = supportedLocales.find(
    (supportedLocale) => supportedLocale.toLowerCase() === normalizedLocale,
  );

  if (exactLocale) {
    return exactLocale;
  }

  const baseLocale = normalizedLocale.split('-')[0];

  const supportedBaseLocale = supportedLocales.find(
    (supportedLocale) => supportedLocale.toLowerCase() === baseLocale,
  );

  return supportedBaseLocale || 'en';
};

/**
 * Returns the matching folder name below public/locales.
 */
export const getLocaleDirectory = (locale) => {
  const canonicalLocale = normalizeLocale(locale);

  return LOCALE_DIRECTORIES[canonicalLocale] || canonicalLocale;
};

export const isDev =
  import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  window.location.hostname === 'localhost';
